"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableHeading = void 0;
var react_1 = __importStar(require("react"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var c = (0, BemBuilder_1.default)("editable-heading");
function EditableHeading(_a) {
    var canEditHeading = _a.canEditHeading, placeholder = _a.placeholder, heading = _a.heading, onUpdateHeading = _a.onUpdateHeading;
    var disabled = canEditHeading != null && !canEditHeading;
    var _b = __read((0, react_1.useState)(), 2), elementWidth = _b[0], setElementWidth = _b[1];
    function onChange(newName) {
        if (onUpdateHeading != null) {
            onUpdateHeading(newName);
        }
    }
    function onFocus(event) {
        if (heading === "Untitled") {
            var inputTarget = event.target;
            if (inputTarget.select) {
                inputTarget.select();
            }
        }
    }
    function resizeElement(width) {
        if (width != undefined) {
            setElementWidth(width + 8 + 25);
        }
    }
    function projectNameError() {
        var htmlCheck = (0, ValidateStrings_1.checkPageName)(heading);
        if (htmlCheck.valid === false) {
            return "Page name ".concat(htmlCheck.error);
        }
        return undefined;
    }
    return (react_1.default.createElement("div", { className: "".concat(c(), " ").concat(c("", "left"), " ").concat(c("", "react-version")), style: { width: "".concat(elementWidth, "px") } },
        react_1.default.createElement(kaleidoscope_1.TextInput, { variant: disabled ? kaleidoscope_1.TextInputVariant.Borderless : kaleidoscope_1.TextInputVariant.Underlined, labelHidden: true, readOnly: disabled, size: kaleidoscope_1.TextInputSize.Small, endElement: disabled ? undefined : react_1.default.createElement(icons_1.Edit, { size: icons_1.IconSize.Small }), label: "Page name", placeholder: placeholder, value: heading, onChange: onChange, onFocus: onFocus, error: projectNameError(), errorVariant: "bottomTooltip", "data-synthetics-selector": "editable-heading-input", "data-testid": "editable-heading-input" }),
        react_1.default.createElement(react_resize_detector_1.default, { handleWidth: true, onResize: resizeElement },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: "".concat(c("sizing-span")) }, heading || placeholder))));
}
exports.EditableHeading = EditableHeading;
